import { Flex, Padding } from 'components/base/layout-components';
import Text, { Inline } from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const BeforeSubmit = ({ email, onSubmit }) => {
  return (
    <Flex direction='column' style={{ alignItems: 'center' }}>
      <Padding
        l='medium'
        r='medium'
        b='x-x-large'
        style={{ textAlign: 'center' }}
      >
        <Inline
          lineHeight='45.5px'
          size='x-x-x-x-large'
          align='center'
          pr='3px'
          weight={400}
        >
          Would you like to unsubscribe email
        </Inline>
        <br />
        <Inline lineHeight='45.5px' size='x-x-x-x-large' weight={500}>
          {email}
        </Inline>
        <Inline
          lineHeight='45.5px'
          size='x-x-x-x-large'
          align='center'
          weight={400}
        >
          ?
        </Inline>
      </Padding>
      <LBButton size='lg' onClick={onSubmit}>
        <Text
          align='center'
          color='white'
          size='x-x-x-large'
          padding='6px 12px 6px 12px'
          weight='800'
          width='18rem'
        >
          UNSUBSCRIBE
        </Text>
      </LBButton>
    </Flex>
  );
};

export default BeforeSubmit;
